/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_DescriptionInputs */

const en_guide_what_is_json_description = /** @type {(inputs: Guide_What_Is_Json_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn what JSON is, how it works, and why it's the most popular data format for web development. Includes examples and practical tips.`)
};

const ko_guide_what_is_json_description = /** @type {(inputs: Guide_What_Is_Json_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON이 무엇인지, 어떻게 작동하는지, 왜 웹 개발에서 가장 인기 있는 데이터 포맷인지 알아보세요. 예제와 실용적인 팁이 포함되어 있습니다.`)
};

const ja_guide_what_is_json_description = /** @type {(inputs: Guide_What_Is_Json_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONとは何か、どのように機能するか、なぜWeb開発で最も人気のあるデータ形式なのかを学びましょう。例と実践的なヒント付き。`)
};

/**
* | output |
* | --- |
* | "Learn what JSON is, how it works, and why it's the most popular data format for web development. Includes examples and practical tips." |
*
* @param {Guide_What_Is_Json_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_description = /** @type {((inputs?: Guide_What_Is_Json_DescriptionInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_DescriptionInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_description(inputs)
	if (locale === "ko") return ko_guide_what_is_json_description(inputs)
	return ja_guide_what_is_json_description(inputs)
});